import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {FormService} from 'src/app/shared/form.service';
import {SharedService} from "../../../shared/shared.service";
import {shareReplay} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class BigPropertyService {
  private url = `/api/v1/calculateInsSums/`;
  private premiumsUrl = `/api/v1/calculatePremiums`;

  constructor(private http: HttpClient, private formService: FormService, public sharedService: SharedService) {
  }

  howBig(area): Observable<any> {
    const {
      propertyCategory,
      propertySubcategory,
      postCode,
      currency,
      city,
      purpose,
      yearOfConstruction,
      street,
      claimsExists
    } = this.formService.currentForm.value;
    const params = {
      propertyCategory,
      propertySubcategory,
      postCode,
      area,
      currency,
      cityName: city,
      purpose,
      yearOfConstruction,
      street,
      claimsExists
    };
    this.sharedService.loadingSpinner = true;

    // return this.sharedService.getProductProposals(params, this.formService.currentForm)

    return this.http.post(this.url, params);
  }

  getInsSumsMovable(data) {
    this.sharedService.insSumsMovable$ = this.http.post('/api/v1/calculate-ins-sums-movable', data).pipe(shareReplay());
    return this.sharedService.insSumsMovable$;
    // return this.http.post('/api/v1/calculate-ins-sums-movable', data)
  }

  calculatePremiums(item?) {
    const formValues = this.formService.currentForm.getRawValue();
    const {
      area,
      currency,
      immovableinsuranceSum,
      movableinsuranceSum,
      immovableinsuranceSumRecommended,
      movableinsuranceSumRecommended,
      immovableinsuranceSumRecommendedCurr2,
      movableinsuranceSumRecommendedCurr2,
      nErr_Code,
      postCode,
      purpose,
      propertyCategory,
      propertySubcategory,
      yearOfConstruction,
    } = formValues;
    const params = {
      area,
      currency,
      immovableinsuranceSumRecommended : item && item.immovableinsuranceSumRecommended || immovableinsuranceSumRecommended,
      movableinsuranceSumRecommended : item && item.movableinsuranceSumRecommended || movableinsuranceSumRecommended,
      immovableinsuranceSumRecommendedCurr2 : item && item.immovableinsuranceSumRecommendedCurr2 || immovableinsuranceSumRecommendedCurr2,
      movableinsuranceSumRecommendedCurr2 : item && item.movableinsuranceSumRecommendedCurr2 || movableinsuranceSumRecommendedCurr2,
      immovableinsuranceSum,
      movableinsuranceSum,
      nErr_Code,
      postCode,
      yearOfConstruction,
      purpose,
      propertyCategory,
      propertySubcategory,
    }
    return this.http.post(this.premiumsUrl, params);
  }
}
